import { render, staticRenderFns } from "./ExistingVsNewOnes.vue?vue&type=template&id=0952ef20&"
import script from "./ExistingVsNewOnes.vue?vue&type=script&lang=js&"
export * from "./ExistingVsNewOnes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports